export default __webpack_public_path__ + "static/media/icon-micro.f92ec263.svg";